import {
  aggregateConditionViolationStatusToTopLevel,
  aggregateConditionViolationTimeseriesToTopLevel,
} from '../data/condition-violations.aggregate';
import {
  aggregatePenaltyOverviewChartToTopLevel,
  aggregatePenaltyOverviewTableToTopLevel,
} from '../data/penalty-overview.aggregate';
import { aggregateWarrantyIdStatusToTopLevel } from '../data/status.aggregate';

type AggregationType =
  | 'warrantyIdStatus'
  | 'penaltyOverviewChart'
  | 'penaltyOverviewTable'
  | 'conditionViolationStatus'
  | 'conditionViolationTimeseries';

export function aggregateDummyData<T>(
  type: AggregationType,
  data: T[],
  level: 'site' | 'top' | 'unit',
): any[] {
  switch (type) {
    case 'warrantyIdStatus':
      return level === 'site'
        ? aggregateWarrantyIdStatusToTopLevel(data as any)
        : data;
    case 'penaltyOverviewChart':
      return level === 'site'
        ? aggregatePenaltyOverviewChartToTopLevel(data as any)
        : data;
    case 'penaltyOverviewTable':
      return level === 'site'
        ? aggregatePenaltyOverviewTableToTopLevel(data as any)
        : data;
    case 'conditionViolationTimeseries':
      return level === 'site'
        ? aggregateConditionViolationTimeseriesToTopLevel(data as any)
        : data;
    case 'conditionViolationStatus':
      return level === 'site'
        ? aggregateConditionViolationStatusToTopLevel(data as any)
        : data;
    default:
      throw new Error(`No aggregator implemented for type: ${type}`);
  }
}
